<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>

<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">
        {{_element?.description}}
      </div>
    </div>
    <div class="new-options d-flex flex-wrap" [class.new-options--radioimage]="_element?.isImage"
      [class.new-options__half-width]="(_element?.options.length > 3 && !_element?.isHorizontallyAlign) || _element?.isImage"
      [class.new-options__twothird-width]="!_element?.isHorizontallyAlign && !_element.isImage">
      <div *ngFor="let opt of _element?.options;index as i" class="new-options--radio">
        <input *ngIf="_element.type == 'EXACT' || _element.type == 'RANGE'" [checked]="map[opt._id]"
          (change)="checkedState($event,opt._id)" type="checkbox" name="{{_element?._id}}">
        <input *ngIf="_element.type == 'SINGLE'" [checked]="map[opt._id]" (change)="radioState(opt._id)"
          type="radio" name="{{_element?._id}}">
        <span class="new-options--color"></span>
        <img *ngIf="_element?.isImage" class="new-options--title" [src]="opt.text" alt="">
        <span *ngIf="!_element?.isImage" class="new-options--title">{{opt.text}}</span>
      </div>
    </div>
    <app-exercise-navigation-bar [id]="id" [questionAttempted]="showNextButton" (onNext)="next()" (onSubmit)="next(true)"
    [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
    [index]='index' 
    ></app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">
        {{_element?.description}}
      </div>
    </div>
    <div class="new-options d-flex flex-wrap" [class.new-options--radioimage]="_element?.isImage"
      [class.new-options__half-width]="(_element?.options.length > 3 && !_element?.isHorizontallyAlign) || _element?.isImage"
      [class.new-options__twothird-width]="!_element?.isHorizontallyAlign && !_element.isImage">
      <div *ngFor="let opt of _element?.options;index as i"
        [class.new-options--right-answer--unchecked]="!map[opt._id] && opt.isCorrect && questionChecked"
        [class.new-options--right-answer]="map[opt._id] && opt.isCorrect && questionChecked"
        [class.new-options--wrong-answer]="map[opt._id] && !opt.isCorrect && questionChecked"
        [class.new-options--has-feedback]="questionAttempted && questionChecked && opt.feedback"
        class="new-options--radio">
        <input [class.disabled]="questionChecked" *ngIf="_element.type == 'EXACT' || _element.type == 'RANGE'" [checked]="map[opt._id]"
          (change)="checkedState($event,opt._id)" type="checkbox" name="{{_element?._id}}">
        <input [class.disabled]="questionChecked" *ngIf="_element.type == 'SINGLE'" [checked]="map[opt._id]"
          (change)="radioState(opt._id)" type="radio" name="{{_element?._id}}">
        <span class="new-options--color"></span>
        <img *ngIf="_element?.isImage" class="new-options--title" [src]="opt.text" alt="">
        <span *ngIf="!_element?.isImage" class="new-options--title">{{opt.text}}</span>
        <div *ngIf="questionChecked && opt.feedback && map[opt._id] && !opt.isCorrect" class="has-feedback">
          <span class="has-feedback--icon">
            <span>?</span>
          </span>
          <div class="has-feedback--dropdown active">
            {{opt.feedback}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="questionAttempted && questionChecked &&  _element?.isFeedbackEnabled" class="overall-feedback pb-0">
      <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
    <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="showNextButton" (onReview)="check()" (onNext)="next()" (onSubmit)="next(true)" [questionChecked]="questionChecked"
    [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
    [index]='index'
    ></app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="isSubmitted" [attr.id]="'destination'+index" [class.new-options--not-answered]="!_answer"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="_element?.isScoring &&  _answer && points  && isResultPublished">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
    </div>
    <div class="new-options d-flex flex-wrap" [class.new-options--radioimage]="_element?.isImage"
      [class.new-options__half-width]="(_element?.options.length > 3 && !_element?.isHorizontallyAlign) ||
      _element?.isImage" [class.new-options__twothird-width]="!_element?.isHorizontallyAlign && !_element.isImage">
      <div *ngFor="let opt of _element?.options;index as i"
        [class.new-options--right-answer--unchecked]="!map[opt._id] && opt.isCorrect && isResultPublished"
        [class.new-options--right-answer]="map[opt._id] && opt.isCorrect && isResultPublished"
        [class.new-options--wrong-answer]="map[opt._id] && !opt.isCorrect && isResultPublished"
        [class.new-options--has-feedback]="_answer && opt.feedback" class="new-options--radio">
        <input class="disabled" [checked]="map[opt._id]" *ngIf="_element.type == 'EXACT' || _element.type == 'RANGE'"
          (change)="checkedState($event,opt._id)" type="checkbox" name="{{_element?._id}}">
        <input class="disabled" [checked]="map[opt._id]" *ngIf="_element.type == 'SINGLE'"
          (change)="radioState(opt._id)" type="radio" name="{{_element?._id}}">
        <span class="new-options--color"></span>
        <img *ngIf="_element?.isImage" class="new-options--title" [src]="opt.text" alt="">
        <span *ngIf="!_element?.isImage" class="new-options--title">{{opt.text}}</span>
        <div *ngIf="_answer && opt.feedback && map[opt._id] && !opt.isCorrect" class="has-feedback">
          <span class="has-feedback--icon">
            <span>?</span>
          </span>
          <div class="has-feedback--dropdown active">
            {{opt.feedback}}
          </div>
        </div>
      </div>
    </div>
     <!-- thrive -->
     <ng-container *ngIf="questionBlos && questionBlos.length">     
      <h5 class="question__thrive">Thrive Skills:</h5>
      <div class="question__thrive-list">
        <ul>
          <ng-container *ngFor="let blo of questionBlos">
            <li [innerHTML]="blo.shortStatement"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <div *ngIf="_element?.isFeedbackEnabled" class="overall-feedback">
      <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
  </div>
  <!-- <app-like-dislike [id]="id" *ngIf="_element?.isFeedbackEnabled" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
